import React from 'react';
import * as LucideIcons from 'lucide-react';

const SafeIcon = ({ name, className = "", ...props }) => {
  // Map common names to Lucide component names
  const iconMap = {
    'Shield': 'ShieldCheck',
    'Settings': 'Sliders',
    'Users': 'Users2',
    'Star': 'Star',
    'MapPin': 'MapPin',
    'Phone': 'Phone',
    'Mail': 'Mail',
    'User': 'UserCircle2',
    'X': 'X',
    'Send': 'SendHorizontal',
    'MessageCircle': 'MessageCircle',
    'Menu': 'Menu',
    'Facebook': 'Facebook',
    'Instagram': 'Instagram',
    'Twitter': 'Twitter'
  };

  const lucideName = iconMap[name] || name;
  const IconComponent = LucideIcons[lucideName];

  if (!IconComponent) {
    console.warn(`Icon "${name}" (mapped to "${lucideName}") not found in lucide-react`);
    return <LucideIcons.AlertTriangle className={`text-amber-500 ${className}`} {...props} />;
  }

  return <IconComponent className={className} {...props} />;
};

export default SafeIcon;